<template>
  <div
    class="consultant-wrap clearfix flex"
    @mouseleave="show=false"
    @mouseenter="show=true"
  >
    <div class="consultant-left flex flex-direction_column align-items_center">
      <span>专</span><span>属</span><span>顾</span><span>问</span>
      <img
        v-show="!show"
        class="consultant-left-img"
        src="@/image/index/icon_left.png"
        alt=""
      >
      <img
        v-show="show"
        class="consultant-left-img"
        src="@/image/index/icon_right.png"
        alt=""
      >
    </div>
    <transition name="el-fade-in">
      <div
        class="consultant-right "
        v-show="show"
        :style="[{'max-height':windowHeight+'px'}]"
      >
        <ul>
          <li v-for="(item,index) in info" :key="index">
            <img :src="item.url">
            <h4>{{item.title}}</h4>
            <span class=" fs18 c_333">{{item.content}}</span>
            <div
              class="consultant-line"
              v-if="index!=(info.length-1)"
            ></div>
          </li>
        </ul>
      </div>
    </transition>

  </div>
</template>

<script>
import code1 from '@/image/index/icon_code_01.png'
import code2 from '@/image/index/icon_code_02.png'
import code3 from '@/image/index/icon_code_03.png'
import code4 from '@/image/index/icon_code_04.png'
import code5 from '@/image/index/icon_code_05.png'
export default {
  data () {
    return {
      show: false,
      windowHeight: document.documentElement.clientHeight ? document.documentElement.clientHeight - 200 : 600,
      info: [{
        title: '【华南地区】',
        content: '陈经理:13560785646',
        url: code1
      }, {
        title: '【华中地区】',
        content: '龚经理:18138449975',
        url: code2
      }, {
        title: '【西南地区】',
        content: '李经理:18620120318',
        url: code3
      }, {
        title: '【华东地区】',
        content: '杨经理:15817233407',
        url: code4
      }]
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>


// WEBPACK FOOTER //
// src/components/consultant/index.vue